import store from '@/store'
import AuthStateHelper from '@/helpers/AuthStateHelper'

export default {
    created() {

        const checkIntervalInSec = 60;

        if( this.$root.checkAuthStateInterval !== undefined ) {
            clearInterval(this.$root.checkAuthStateInterval)
        }

        this.$root.checkAuthStateInterval = setInterval(() => {
            store.dispatch('auth/fetchInfo', {silent: true}).then(() => {
                AuthStateHelper.checkState(this.$router.currentRoute, (to) => {
                    this.$router.push(to)
                })
            })
        }, checkIntervalInSec * 1000)
    },

    beforeRouteLeave(to, from, next) {
        // refresh auth info when we change route
        store.dispatch('auth/fetchInfo').then(() => {
            next()
        })
    },

    beforeRouteEnter (to, from, next) {

        let promise = Promise.resolve()

        // DEV SERVER ONLY - in case of webpack dev-server we have empty _appConfig.auth.users so we need to fetch them first
        if( _appConfig.mode === 'dev' )
        {
            promise = store.dispatch('auth/fetchInfo')
        }

        promise.then(() => {

            if (to.params.skipAuthStateCheck) {
                next()
                return
            }

            AuthStateHelper.checkState(to, next, next)
        })
    }
}
